module.exports = __webpack_public_path__ + "img/588x310-02.0bb5b72e.png";